<div class="cohere-dialog">
  <button
    class="close-btn"
    mat-icon-button
    (click)="close()"
    aria-label="Close Cohere R+ Info"
  >
    ×
  </button>

  <div class="header">
    <img src="assets/logos/cohere.svg" alt="Cohere R+ Logo" class="mini-logo" />
    <h2>Cohere&nbsp;R+</h2>
    <div class="sub">Enterprise-grade model built for reliable language understanding, retrieval, and governed AI</div>
  </div>

  <div class="body">
    <p>
      <strong>Cohere&nbsp;R+</strong> is an enterprise-focused large language model designed for
      <strong>consistent</strong>, <strong>controllable</strong>, and <strong>production-ready</strong> results.
      It’s commonly used for business workflows like <strong>search and retrieval</strong>, <strong>summarization</strong>,
      <strong>knowledge assistants</strong>, and <strong>RAG</strong> (retrieval-augmented generation), where grounding responses in
      company documents is critical.
    </p>

    <ul>
      <li>🏢 <strong>Enterprise reliability:</strong> optimized for stable behavior, predictable formatting, and scalable usage patterns.</li>
      <li>🔎 <strong>Retrieval-first strength:</strong> strong fit for knowledge-base Q&amp;A, document search, and grounded generation.</li>
      <li>🧾 <strong>Business writing quality:</strong> summaries, briefs, memos, and customer-facing copy with consistent tone.</li>
      <li>🛡️ <strong>Governance-friendly:</strong> often chosen when safety, compliance, and output control are key requirements.</li>
      <li>⚙️ <strong>Integration-ready:</strong> designed to connect cleanly into production stacks, tools, and data pipelines.</li>
    </ul>

    <div class="optimal">
      <h3>Best when to use Cohere&nbsp;R+</h3>
      <ul>
        <li>When you need <strong>reliable, controlled</strong> outputs for enterprise applications</li>
        <li>For <strong>RAG</strong> systems that answer using internal documentation and knowledge sources</li>
        <li>When <strong>compliance and safety</strong> requirements are non-negotiable</li>
        <li>For summarization, chat, and Q&amp;A workflows that must stay consistent at scale</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>How to get the best results</h3>
      <ul>
        <li><strong>Ground answers:</strong> provide source text or connect retrieval so responses stay anchored to facts.</li>
        <li><strong>Specify output format:</strong> sections, bullets, tables, or JSON for consistent downstream use.</li>
        <li><strong>Set constraints:</strong> tone, length, and must-include/must-not-include requirements.</li>
        <li><strong>Evaluate regularly:</strong> keep a small test set of prompts to regression-test quality over time.</li>
      </ul>
    </div>
  </div>
</div>
